import { NzConfig } from 'ng-zorro-antd/core/config';

// (alert.service) - https://ng.ant.design/components/notification/en - Global Configuration
export const NG_ZORRO_CONFIG: NzConfig = {
  notification: {
    nzTop: '82px', //The top of the notification when it pops up from the top.
    nzMaxStack: 6 //The maximum number of notifications that can be displayed at the same time
  }
};
